'use client';

import moment from 'moment-timezone';
import { MdHeadsetMic, MdPhone } from 'react-icons/md';

import RequestCallbackModal from '@/components/ContactHeader/RequestCallbackModal';
import FilledMoonStars from '@/components/Icons/FilledMoonStarts';
import { useTranslation } from '@/contexts/dictionaryContext';
import { useLocale } from '@/hooks/useLocale';
import { cn } from '@/lib/utils';

function getEstablishmentIsOpen() {
  let establishmentIsOpen = true;

  const currentDate = moment().tz('Europe/Rome');
  const currentDay = currentDate.day();
  const currentHour = currentDate.hour();
  const currentMinutes = currentDate.minutes();

  const isWeekDay = currentDay > 0 && currentDay < 6;
  const isSaturday = currentDay === 6;
  const isSunday = currentDay === 0;

  if (isWeekDay) {
    if (
      currentHour < 9 ||
      (currentHour === 9 && currentMinutes < 30) ||
      currentHour >= 18
    ) {
      establishmentIsOpen = false;
    }
  }

  if (isSaturday) {
    if (
      currentHour < 9 ||
      (currentHour === 9 && currentMinutes < 30) ||
      currentHour >= 13 ||
      (currentHour === 13 && currentMinutes > 30)
    ) {
      establishmentIsOpen = false;
    }
  }

  if (isSunday) {
    establishmentIsOpen = false;
  }

  return establishmentIsOpen;
}

export function TeamStatus() {
  const {
    newHeader: { sideMenu },
    header,
    contactUs,
    countries,
  } = useTranslation();
  const lang = useLocale();
  const isOpen = getEstablishmentIsOpen();

  return (
    <div className="bg-[#F8F4E8] rounded-lg p-4 flex flex-col gap-3">
      {isOpen ? (
        <div className="flex items-start gap-5">
          <div className="size-14 ml-4 rounded-full bg-white flex items-center justify-center shrink-0">
            <MdPhone className="size-7 text-primary" />
          </div>
          <div className="flex flex-col gap-0.5 min-w-0">
            <p className="font-averta-semibold text-sm leading-snug">
              {sideMenu.onlineTitle}
            </p>
            <a
              href={`tel:${header.nav.phone.replace(/\D/g, '')}`}
              className="text-sm text-graphite"
              title="Contact Us">
              {header.nav.phone}
            </a>
            <span className="text-green-500 text-sm flex items-center gap-1.5 mt-0.5 before:content-[''] before:size-1.5 before:rounded-full before:bg-current">
              {sideMenu.availableNow}
            </span>
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-5">
          <div className="size-14 ml-4 rounded-full bg-white border border-gray-300 flex items-center justify-center shrink-0">
            <FilledMoonStars className="size-7 fill-primary" />
          </div>
          <div className="flex flex-col gap-1 min-w-0">
            <p className="font-averta-semibold text-warning text-sm leading-snug">
              {sideMenu.offlineTitle}
            </p>
            <p className="text-sm text-graphite leading-snug">
              {sideMenu.offlineDescription}
            </p>
          </div>
        </div>
      )}

      <RequestCallbackModal
        lang={lang}
        dict={contactUs}
        countriesDict={countries}>
        <button
          type="button"
          className={cn(
            'w-full flex items-center justify-center gap-2 uppercase text-sm font-averta-semibold tracking-wide py-2.5 px-4 rounded border-2 bg-white transition-colors',
            isOpen
              ? 'border-primary text-primary hover:bg-primary/5'
              : 'border-warning text-warning hover:bg-warning/5',
          )}>
          <MdHeadsetMic className="size-5" />
          {sideMenu.requestCallback}
        </button>
      </RequestCallbackModal>
    </div>
  );
}
